import PropTypes from 'prop-types';
import {Header} from 'semantic-ui-react';
import './PropertyHistory.scss';
import LoadingPanel from '../components/LoadingPanel/LoadingPanel';
import {DisclaimerMark} from 'components/DisclaimerMark';
import {removePDFDisclaimerMark} from 'components/DataUpdateForm/DataUpdateForm';

export default function PropertyHistory({history, isLoading}) {
  return (<div className="property-history">
    <Header>Your Property History</Header>
    <LoadingPanel isLoading={isLoading}>
      {history.map(({date, description, dateIsEdited, priceIsEdited}, i) => (
        <div key={i} className="history-item">
            <div className="date">{removePDFDisclaimerMark(date)}{dateIsEdited && <DisclaimerMark/>}</div>
          <div className="description">{removePDFDisclaimerMark(description)}{priceIsEdited && <DisclaimerMark/>}</div>
        </div>
      ))}
    </LoadingPanel>
  </div>);
}

PropertyHistory.propTypes = {
  history: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired).isRequired,
  isLoading: PropTypes.bool,
};

PropertyHistory.defaultProps = {
  isLoading: true,
};